// Ensure grecaptcha object exists
if (typeof window.grecaptcha === 'undefined') {
  window.grecaptcha = {};
}

function setupGrecaptchaReady(isEnterprise) {
  const grecaptchaObj = isEnterprise ? window.grecaptcha.enterprise : window.grecaptcha;

  if (!grecaptchaObj) {
    if (isEnterprise) {
      window.grecaptcha.enterprise = {};
    } else {
      window.grecaptcha = {};
    }
  }

  const targetObj = isEnterprise ? window.grecaptcha.enterprise : window.grecaptcha;

  targetObj.ready = function (cb) {
    if (typeof window.grecaptcha === 'undefined') {
      const c = '___grecaptcha_cfg';
      window[c] = window[c] || {};
      (window[c]['fns'] = window[c]['fns'] || []).push(cb);
    } else {
      cb();
    }
  };
}

// Set up both regular and enterprise ready functions
// (low overhead and more robust against partial loading scenarios)
setupGrecaptchaReady(false);
setupGrecaptchaReady(true);

window.displayReCaptchaError = function(form, errorMessage) {
  const existingError = form.querySelector('#recaptcha-error');
  if (existingError) {
    existingError.remove();
  }

  form.lastElementChild.insertAdjacentHTML(
    'afterend',
    '<span id="recaptcha-error" class="validation-error-text" aria-live="polite">' +
    errorMessage +
    '</span>'
  );
}

window.requestReCaptchaToken = function(form, callback) {
  const reCaptchaTokenInput = form.querySelector(
    'input[name="g-recaptcha-response"]'
  );
  if (!reCaptchaTokenInput) {
    console.error('ReCaptcha token input not found in form');
    return;
  }

  // Get the site key and action from data attributes on the token input
  const siteKey = reCaptchaTokenInput.dataset.sitekey;
  const action = reCaptchaTokenInput.dataset.action;
  const isEnterprise = reCaptchaTokenInput.dataset.enterprise === 'true';

  if (!siteKey || !action) {
    console.error(
      'ReCaptcha site key or action not found in token input data attributes'
    );
    return;
  }
  
  const grecaptchaObj = isEnterprise ? window.grecaptcha.enterprise : window.grecaptcha;

  return grecaptchaObj
    .execute(siteKey, { action: action })
    .then(function (token) {
      reCaptchaTokenInput.value = token;
      if (callback) {
        callback();
      }
    })
    .catch(function () {
      const submitter = form.querySelector('button.btn-primary');
      if (submitter) {
        submitter.disabled = false; // re-enable submit button on error
      }
      window.displayReCaptchaError(
        form,
        'Unable to complete ReCaptcha request.'
      );
    });
}

// Main handler function
window.handleReCaptchaAndSubmit = function (form, submitter) {
  submitter = submitter || form.querySelector('button.btn-primary');
  if (submitter) {
    submitter.disabled = true; // prevent double submission
  }

  window.requestReCaptchaToken(form, function () {
    if (submitter && submitter.formAction && submitter.formAction !== '') {
      form.action = submitter.formAction;
    }
    form.submit();
  });
};
